import React, { Component } from "react";
import Desplegable from "../../desplegable";
import VistaGrupoTrabajo from "../vistas/vista_grupo_trabajo";
import FormGrupoTrabajo from "../formularios/form_grupo_trabajo";

export default class DesplegableGrupoTrabajo extends Component {
  render() {
    return (
      <Desplegable
        eventKey="0"
        id="0"
        Toogle="Datos del Equipo/Comisión"
        handleButtonShow={this.props.handleButtonShow}
        showModal={this.props.state.showModalArray[0]}
        Text={<VistaGrupoTrabajo DatosGrupoTrabajo={this.props.state.DatosGrupoTrabajo} Finalidad={this.props.state.Finalidad}></VistaGrupoTrabajo>}
        Form={
          <FormGrupoTrabajo
            DatosGrupoTrabajo={this.props.state.DatosGrupoTrabajo}
            Finalidad={this.props.state.Finalidad}
            setFinalidad={this.props.setFinalidad}
            setInformacionOrganismo={this.props.setInformacionOrganismo}
            id_provincia={this.props.id_provincia}
            handleButtonShow={this.props.handleButtonShow}
            nullField={this.props.nullField}
            setAlert={this.props.setAlert}
            ErrorHandling={this.props.ErrorHandling}
          ></FormGrupoTrabajo>
        }
        canEdit={true}
      />
    );
  }
}
